var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Link, NavLink } from "react-router-dom";
import { Button, Dimmer, Form, Grid, Header, Input, Loader, Message, Modal, } from "semantic-ui-react";
import SimpleFormWithErrorDisplay from "./admin/SimpleFormWithErrorDisplay";
import { AppPaths } from "./AppConfig";
import ErrorDisplay from "./ErrorDisplay";
import FieldWithErrorDisplay from "./FieldWithErrorDisplay";
import GenerateReferralLinkModal from "./GenerateReferralLinkModal";
import ProfileEditForm from "./ProfileEditForm";
import { getWithAuthn, postJsonWithAuthn } from "./RequestHelpers";
var ProfilePage = /** @class */ (function (_super) {
    __extends(ProfilePage, _super);
    function ProfilePage(props) {
        var _this = _super.call(this, props) || this;
        _this.generateRenderModal = function (profile) {
            return function (props) {
                return React.createElement(GenerateReferralLinkModal, __assign({ referralId: profile.referral.referralId.id, referralType: profile.referral.referralId._type, admin: false }, props));
            };
        };
        _this.loadProfile = function () {
            _this.setState({
                loading: true,
                profile: undefined
            }, function () {
                getWithAuthn('/user/profile')
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            profile: undefined
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            profile: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load profile: " + rej);
                });
            });
        };
        _this.state = {
            loading: true,
            profile: undefined
        };
        return _this;
    }
    ProfilePage.prototype.render = function () {
        var valueWidth = 12;
        return React.createElement("div", { id: "non-header-portion" },
            React.createElement(Dimmer.Dimmable, { as: 'div' },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                this.state.profile &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Grid, { className: 'tight-rows', columns: 4 },
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(NavLink, { to: AppPaths.ORDERS },
                                        React.createElement(Button, null, "Orders")))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(NavLink, { to: AppPaths.LOG_OUT },
                                        React.createElement(Button, null, "Log Out")))),
                            React.createElement(Header, null, "Personal"),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null, "Name"),
                                React.createElement(Grid.Column, { width: valueWidth }, this.state.profile.name)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null, "Email"),
                                React.createElement(Grid.Column, { width: valueWidth }, this.state.profile.email)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null, "Organization"),
                                React.createElement(Grid.Column, { width: valueWidth }, this.state.profile.organization)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null, "Research group"),
                                React.createElement(Grid.Column, { width: valueWidth }, this.state.profile.researchGroup)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null, "Phone"),
                                React.createElement(Grid.Column, { width: valueWidth }, this.state.profile.phone)),
                            React.createElement(Header, null, "Shipping Info"),
                            addressGridRows(this.state.profile.shippingAddress, 4, 12),
                            React.createElement(Header, null, "Billing Info"),
                            addressGridRows(this.state.profile.billingAddress, 4, 12),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null, "Billing Email"),
                                React.createElement(Grid.Column, { width: valueWidth }, this.state.profile.billingEmail)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null, "Billing Phone"),
                                React.createElement(Grid.Column, { width: valueWidth }, this.state.profile.billingPhone))),
                        React.createElement("div", { style: { 'marginTop': '2rem' } },
                            React.createElement(Modal, { closeIcon: true, onClose: this.loadProfile, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit profile', labelPosition: 'left', style: { 'marginRight': '1rem' } }) },
                                React.createElement(Modal.Header, null, "Update profile"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(ProfileEditForm, { buttonIcon: 'save', buttonLabel: 'Save changes', disableOnSuccess: true, endpoint: '/user/profile', hideOnSuccess: true, includePassword: false, initialProfile: this.state.profile, successHeader: 'Profile updated', successMessage: React.createElement(React.Fragment, null), legalInput: false, categoryInput: false, referredByInput: false, sendSignUpGaEvent: false }))),
                            React.createElement(Modal, { closeIcon: true, size: 'small', trigger: React.createElement(Button, { icon: 'privacy', label: 'Change password', labelPosition: 'left' }) },
                                React.createElement(Modal.Header, null, "Change password"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(ChangePasswordModal, null)))),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement("div", null,
                            React.createElement(Grid, { className: 'tight-rows', columns: 4 },
                                React.createElement(Header, null, "Referral Link"),
                                React.createElement(Grid.Row, null,
                                    React.createElement(Grid.Column, { width: valueWidth }, this.state.profile.referral.bitlyLink === null ?
                                        React.createElement(SimpleFormWithErrorDisplay, { render: this.generateRenderModal(this.state.profile), successMessage: 'Reload page to view link.' }) :
                                        // We remove the https:// because we dont want to show this to the user but
                                        // the link remains the same. i.e. no tampering
                                        React.createElement("a", { href: this.state.profile.referral.bitlyLink }, this.state.profile.referral.bitlyLink.replace("https://", ""))))))),
                !this.state.loading
                    && this.state.profile === undefined
                    && React.createElement("div", null,
                        React.createElement(Link, { to: AppPaths.LOG_IN }, "Please log in."))));
    };
    ProfilePage.prototype.componentDidMount = function () {
        this.loadProfile();
    };
    return ProfilePage;
}(React.PureComponent));
export default ProfilePage;
export var addressGridRows = function (address, labelWidth, valueWidth) {
    return React.createElement(React.Fragment, null,
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: labelWidth }, "Street Address"),
            React.createElement(Grid.Column, { width: valueWidth }, address.street)),
        address.streetLine2 !== "" && React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: labelWidth }, "Room/Suite/Other"),
            React.createElement(Grid.Column, { width: valueWidth }, address.streetLine2)),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: labelWidth }, "City"),
            React.createElement(Grid.Column, { width: valueWidth }, address.city)),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: labelWidth }, "State / Province"),
            React.createElement(Grid.Column, { width: valueWidth }, address.stateProvince)),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: labelWidth }, "Zip / Postal Code"),
            React.createElement(Grid.Column, { width: valueWidth }, address.zipPostalCode)),
        React.createElement(Grid.Row, null,
            React.createElement(Grid.Column, { width: labelWidth }, "Country"),
            React.createElement(Grid.Column, { width: valueWidth }, address.countryCode)));
};
var ChangePasswordModal = /** @class */ (function (_super) {
    __extends(ChangePasswordModal, _super);
    function ChangePasswordModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onCurrentPasswordChange = function (event, data) {
            var str = data.value;
            _this.setState({ currentPassword: str });
        };
        _this.onNewPasswordChange = function (event, data) {
            var str = data.value;
            _this.setState({ newPassword: str });
        };
        _this.onSubmit = function () {
            _this.setState({
                loading: true
            }, function () {
                var reqBody = {
                    currentPassword: _this.state.currentPassword,
                    newPassword: _this.state.newPassword,
                };
                postJsonWithAuthn('/user/password', JSON.stringify(reqBody))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            errors: [],
                            success: true
                        });
                        return;
                    }
                    else if (resp.status === 400) {
                        return resp.json();
                    }
                    else {
                        _this.setState({
                            loading: false,
                            success: false,
                            errors: [{
                                    path: '/',
                                    msg: 'Change password failed'
                                }]
                        });
                        return;
                    }
                })
                    .then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            loading: false,
                            errors: resp.errors,
                            success: false
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't log in: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            errors: [],
            success: false,
            currentPassword: '',
            newPassword: ''
        };
        return _this;
    }
    ChangePasswordModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(FieldWithErrorDisplay, { disabled: this.state.success, errorPath: '/currentPassword', errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Current Password"), required: true },
                React.createElement(Input, { type: 'password', onChange: this.onCurrentPasswordChange, value: this.state.currentPassword })),
            React.createElement(FieldWithErrorDisplay, { disabled: this.state.success, errorPath: '/newPassword', errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "New Password"), required: true },
                React.createElement(Input, { type: 'password', onChange: this.onNewPasswordChange, value: this.state.newPassword })),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Your password has been changed."),
            React.createElement(Button, { disabled: this.state.success, icon: 'save', label: 'Change password', labelPosition: 'left', onClick: this.onSubmit, positive: true }));
    };
    return ChangePasswordModal;
}(React.PureComponent));
//# sourceMappingURL=ProfilePage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/ProfilePage.js
// module id = 349
// module chunks = 0